import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
  MenuItem,
} from "@mui/material";
import { ButtonSx, textFieldSx } from "../styles/GlobalStyles";
import useFeedbackStore from "../store/feedbackStore";

const FeedbackForm = ({ open, onClose, onSubmit }) => {
  const {
    form,
    errors,
    setField,
    setError,
    resetForm,
  } = useFeedbackStore();

  const handleBlur = (field) => {
    const value = form[field].trim();
    let isError = false;

    if (field === "phone") {
      isError = !value || !/^\d{10}$/.test(value);
    } else if (field === "email") {
      isError = !value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    } else {
      isError = !value;
    }

    setError(field, isError);
  };

  const handleFocus = (field) => {
    setError(field, false);
  };

  const handleSubmit = () => {
    onSubmit(form);
    resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Feedback Form</DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Name"
          fullWidth
          variant="outlined"
          name="name"
          value={form.name}
          error={errors.name}
          onFocus={() => handleFocus("name")}
          onBlur={() => handleBlur("name")}
          onChange={(e) => setField("name", e.target.value)}
          helperText={errors.name ? "Name field is required" : ""}
          margin="normal"
          required
          FormHelperTextProps={{
            sx: { marginLeft: 0, fontWeight: "bold", color: "error.main" },
          }}
          sx={textFieldSx}
        />
        <TextField
          label="Phone"
          fullWidth
          variant="outlined"
          name="phone"
          value={form.phone}
          error={errors.phone}
          onFocus={() => handleFocus("phone")}
          onBlur={() => handleBlur("phone")}
          onChange={(e) => setField("phone", e.target.value)}
          helperText={errors.phone ? "Invalid Phone Number" : ""}
          margin="normal"
          required
          FormHelperTextProps={{
            sx: { marginLeft: 0, fontWeight: "bold", color: "error.main" },
          }}
          sx={textFieldSx}
        />
        <TextField
          label="Email"
          fullWidth
          variant="outlined"
          name="email"
          value={form.email}
          error={errors.email}
          onFocus={() => handleFocus("email")}
          onBlur={() => handleBlur("email")}
          onChange={(e) => setField("email", e.target.value)}
          helperText={errors.email ? "Invalid Email" : ""}
          margin="normal"
          required
          FormHelperTextProps={{
            sx: { marginLeft: 0, fontWeight: "bold", color: "error.main" },
          }}
          sx={textFieldSx}
        />
        <TextField
          label="Category"
          fullWidth
          variant="outlined"
          name="category"
          value={form.category}
          error={errors.category}
          onFocus={() => handleFocus("category")}
          onBlur={() => handleBlur("category")}
          onChange={(e) => setField("category", e.target.value)}
          helperText={errors.category ? "Category is required" : ""}
          margin="normal"
          required
          select
          FormHelperTextProps={{
            sx: { marginLeft: 0, fontWeight: "bold", color: "error.main" },
          }}
          sx={textFieldSx}
        >
          <MenuItem value="Bug Report">Bug Report</MenuItem>
          <MenuItem value="Feature Request">Feature Request</MenuItem>
          <MenuItem value="General Suggestion">General Suggestion</MenuItem>
          <MenuItem value="UI/UX Feedback">UI/UX Feedback</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </TextField>
        <TextField
          label="Message"
          fullWidth
          variant="outlined"
          name="message"
          multiline
          minRows={6}
          value={form.message}
          error={errors.message}
          onFocus={() => handleFocus("message")}
          onBlur={() => handleBlur("message")}
          onChange={(e) => setField("message", e.target.value)}
          helperText={errors.message ? "Message field is required" : ""}
          margin="normal"
          required
          FormHelperTextProps={{
            sx: { marginLeft: 0, fontWeight: "bold", color: "error.main" },
          }}
          sx={textFieldSx}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" sx={{ color: "#02042D" }}>
          Cancel
        </Button>
        <Button
          disabled={
            !form.name || !form.phone || !form.email || !form.category || !form.message
          }
          onClick={handleSubmit}
          variant="contained"
          sx={ButtonSx}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackForm;
